<template>
  <div class="center-bottom-stats">
    <div class="stats-container" v-if="statsData">
      <div  class="stat-item" >
        <!-- 雷达扫描图标 -->
        <div class="radar-icon">
          <img src="~@/assets/large/radar1.gif" alt="" class="radar-img" />
        </div>
        <!-- 数值和标签 -->
        <div class="stat-content">
          <div class="stat-value">{{ this.statsData.clinic_report.yunzhensuo_cnt }}</div>
          <div class="stat-label">云诊所</div>
        </div>
      </div>
      <div  class="stat-item"  >
        <!-- 雷达扫描图标 -->
        <div class="radar-icon">
          <img src="~@/assets/large/radar1.gif" alt="" class="radar-img" />
        </div>
        <!-- 数值和标签 -->
        <div class="stat-content">
          <div class="stat-value">{{ this.statsData.clinic_report.padzhensuo_cnt }}</div>
          <div class="stat-label">Pad诊所</div>
        </div>
      </div>
      <div  class="stat-item"  >
        <!-- 雷达扫描图标 -->
        <div class="radar-icon">
          <img src="~@/assets/large/radar1.gif" alt="" class="radar-img" />
        </div>
        <!-- 数值和标签 -->
        <div class="stat-content">
          <div class="stat-value">{{ this.statsData.clinic_report.doctor_cnt }}</div>
          <div class="stat-label">医生数</div>
        </div>
      </div>
      <div  class="stat-item" >
        <!-- 雷达扫描图标 -->
        <div class="radar-icon">
          <img src="~@/assets/large/radar1.gif" alt="" class="radar-img" />
        </div>
        <!-- 数值和标签 -->
        <div class="stat-content">
          <div class="stat-value">{{ this.statsData.patient_report.patient_cnt }}</div>
          <div class="stat-label">患者数</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenterBottomStats',
  props:{
    params: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      statsData: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatValue(value) {
      // 添加千分位分隔符
      return value.toLocaleString('zh-CN')
    },
    loadData() {
      // 这里可以调用接口获取统计数据
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_report", this.params).then((res) => {
        if (res && res.data) {
          this.statsData = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center-bottom-stats {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  color: #fff;

  .stats-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    gap: 15px;
    padding: 0 15px;

    .stat-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .radar-icon {
        width: 53px;
        height: 53px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex-shrink: 0;

        .radar-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .stat-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;

        .stat-value {
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          line-height: 1.2;
          margin-bottom: 2px;
          letter-spacing: 0.5px;
          font-family: 'Arial', sans-serif;
        }

        .stat-label {
          font-size: 13px;
          color: #999;
          line-height: 1.2;
          font-weight: 400;
          letter-spacing: 0.5px;
          opacity: 0.7;
        }
      }
    }
  }
}

</style>

